module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Medium.1a1135fb.woff";